<template>

    <FlashNotifications ref="flash" />
    <section >
        <div class="md:px-12 lg:px-20 xl:px-32 xl:max-w-[85rem] mx-auto">
            <div class="px-2 md:px-0 md:flex justify-between items-center my-5">
                <div class="flex overflow-x-auto">
                    <p class="text-xs sm:text-sm whitespace-nowrap px-2 py-1 text-gray-600 rounded sm:hover:bg-gray-100 hover:cursor-pointer dark:text-gray-400 dark:hover:bg-gray-500" 
                        :class="selectCategoryAllClasses()"
                        @click="selectCategoryAll" >
                        {{ I18N.application.integrations.categories.all_integrations }}
                    </p>
                    <span v-for="category in uniqueCategories" :key="category">
                        <p class="text-xs sm:text-sm whitespace-nowrap px-2 py-1 text-gray-600 flex hover:cursor-pointer sm:hover:bg-gray-100 rounded dark:text-gray-400 dark:hover:bg-gray-500"
                           :class="selectedCategoryClasses(category)"
                            @click="selectCategory(category)">
                            {{ category }}
                        </p>
                    </span>    
                </div>
                    
                <div class="relative w-full mt-4 md:mt-0 md:w-fit ">
                    <span class="h-full absolute inset-y-0 left-0 flex items-center pl-2">
                        <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500 dark:text-gray-400">
                            <path
                               d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z">
                            </path>
                        </svg>
                    </span>
                    <input :placeholder="I18N.application.attendees.search_placeholder"
                        v-model="search_str"
                        class="w-full md:w-[250px] appearance-none rounded border border-gray-300 border-b focus:border-0 transition focus:ring-2 focus:ring-blue-600 block pl-8 pr-6 py-1.5 w-full bg-white text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:outline-none dark:bg-[#1C2128] dark:border-gray-400/70 dark:focus:ring-gray-400 dark:text-gray-400" />
                </div>                    
            </div>
            
            <div class="mb-10 md:rounded md:shadow-lg overflow-auto md:shadow-gray-300 border-r border-t border-l border-gray-200 dark:border-gray-500 dark:shadow-gray-600/60">
                <div v-for="(integration, index) in filteredIntegrations" :key="index">
                    <div class="flex flex-col px-6 py-4 md:flex-row md:justify-between bg-white border-b border-gray-200 dark:bg-[#1C2128] dark:border-gray-500">
                        <div class="flex md:items-center mb-3 md:mb-0">
                            <div class="flex justify-center items-center w-12 h-12 rounded-full bg-white border border-slate-100 shadow-lg shadow-gray-300 dark:shadow-gray-600/60">
                                <div class="w-12 flex justify-center items-center">
                                    <img class="w-8 h-8" :src="integration.logo">
                                </div>
                            </div>
                            <div class="px-5 flex flex-col items-center">
                                <div class="text-lg dark:text-gray-400 place-self-start">{{ integration.name }}</div>
                                <div class="text-gray-500 text-sm sm:text-md place-self-start dark:text-gray-400">{{ integration.description }}</div>
                            </div>
                        </div>       
                        <div class="w-full md:w-28 mt-1.5 md:mt-0 md:self-center">
                            <button
                              v-if="integration.user_integration_id !== null"
                              @click="integration_api(integration, 'disable')"
                              @mouseenter="isHovered[index] = true"
                              @mouseleave="isHovered[index] = false"
                              type="button"
                              class="w-full md:w-28 text-white bg-blue-600 hover:bg-white hover:border hover:border-gray-300 font-medium rounded text-sm py-2 text-center hover:text-red-500 dark:hover:bg-gray-700"
                            >
                              <span v-if="isHovered[index]" class="flex items-center justify-center">
                                <svg class="h-5 w-5 inline-block fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.949 14.121 19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0l-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121a2.723 2.723 0 0 1-.844.57L13.414 12l1.414-1.414-.707-.707a4.965 4.965 0 0 0-3.535-1.465c-.235 0-.464.032-.691.066L3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.536-5.536c.277-.184.538-.396.778-.636zm-6.363 3.536a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l1.476-1.475-1.414-1.414L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707z"></path></svg>
                                {{ I18N.website_content.connected_calendar.disconnect }}
                            </span>
                            <span v-else class="flex items-center justify-center">
                                <svg class="h-5 w-5 inline-block fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"></path><path d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"></path></svg>
                                {{ I18N.application.integrations.connected }}
                            </span>
                            </button>
                            <button v-else type="button" 
                                    @click="integration_api(integration, 'enable')"
                                    class="w-full md:w-28 text-gray-600 bg-white border hover:bg-blue-50 font-medium rounded text-sm px-3 py-2 text-center border-gray-400 dark:border-gray-400 dark:text-gray-400 dark:bg-[#1C2128] dark:hover:bg-gray-500 ">
                                        {{ I18N.application.integrations.connect }}
                            </button>
                        </div>
                    </div>  
                </div>
            </div> 
        </div>
    </section>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import Formatting from "controllers/vue_components/mixins/formatting"
import FlashNotifications from "controllers/vue_components/flash_toast"

export default {
    name: 'IntegrationsList',
    mixins: [RequestMixin, Constants, Formatting],
    components: {
        FlashNotifications
    },
    props: ['integrations_json'],
    data() {
        return {
            integrations: [],
            search_str: '',
            selectedCategory: '',
            isHovered: [],
        };
    },
    methods: {
        async integration_api(integration, action) {
            if (integration.single_click_enable) {
                let endpoint = ''
                let resp = {}
                if (action === 'enable') {
                    endpoint = `/integrations/${integration.integration_id}/activate`
                    resp = await this.axiosRequest('POST', endpoint, {}, false)
                } else if (action === 'disable') {
                    endpoint = `/integrations/${integration.user_integration_id}/deactivate`
                    resp = await this.axiosRequest('DELETE', endpoint, {}, false)
                }

                if (resp.js_error == false && resp.response.success) {
                    const integrationIndex = this.integrations.findIndex(
                        (item) => item.integration_id === integration.integration_id
                    );
                    if (integrationIndex !== -1) {
                        this.isHovered[integrationIndex] = false;
                    }

                    this.integrations = resp.response.data.current_user_integrations;
                    this.$refs.flash.show(resp.response.message, 'notice');
                } else {
                    this.$refs.flash.show(resp.response.message, 'alert');
                }

            }
            else if (integration.locale_name === 'external_payments') {
                window.location.href = '/integrations/external_payments';
            } else if (integration.locale_name === 'zoom') {
                let resp = {}
                if (action === 'enable') {
                    window.location.href = 'https://zoom.us/oauth/authorize?response_type=code&client_id=xaA7iC1yQ13BVxuT2vv3w&redirect_uri=https%3A%2F%2Fweekler.co%2Finteg%2Fauth';
                } else if (action === 'disable') {
                    if (window.confirm("If you disconnect, your location will be changed to no location. Are you sure you want to continue?")) {
                        let endpoint = `/zoom/rtoken`
                        resp = await this.axiosRequest('GET', endpoint, {}, false)
                        if (resp.js_error == false && resp.response.success) {
                            const integrationIndex = this.integrations.findIndex(
                                (item) => item.integration_id === integration.integration_id
                            );
                            if (integrationIndex !== -1) {
                                this.isHovered[integrationIndex] = false;
                            }

                            this.integrations = resp.response.data.current_user_integrations;
                            this.$refs.flash.show(resp.response.message, 'notice');
                        } else {
                            this.$refs.flash.show(resp.response.message, 'alert');
                        }
                    } else {
                        // User clicked "Cancel," do nothing or handle accordingly
                    }
                }
            }
            else if (integration.locale_name === 'zoom') {
                window.location.href = 'https://zoom.us/oauth/authorize?response_type=code&client_id=xaA7iC1yQ13BVxuT2vv3w&redirect_uri=https%3A%2F%2Fe7ca-72-255-42-55.ngrok-free.app%2Finteg%2Fauth';
            } else if (integration.locale_name === 'webhooks') {
                window.location.href = '/integrations/webhooks';
            } else {
                console.log('need to add custom logic')
            }
        },

        selectCategory(category) {
            this.selectedCategory = category;
        },
        selectCategoryAll() {
            this.selectedCategory = '';
        },
        selectedCategoryClasses(category) {
            if (this.selectedCategory === category)
                return 'bg-blue-100/80 text-blue-800 font-medium transition ease-in-out sm:hover:bg-blue-100/80 hover:text-blue-900 dark:bg-[#1C2128] dark:sm:hover:bg-gray-700 dark:text-gray-400 dark:hover:text-white';
        },
        selectCategoryAllClasses() {
            if (this.selectedCategory === '')
                return 'bg-blue-100/80 text-blue-800 font-medium transition ease-in-out sm:hover:bg-blue-100/80 hover:text-blue-900 dark:bg-[#1C2128] dark:sm:hover:bg-gray-700 dark:text-gray-400 dark:hover:text-white';
        }
    },

    computed: {
        uniqueCategories() {
            const categories = new Set();
            this.integrations.forEach((integration) => {
                categories.add(integration.category);
            });
            const sortedCategories = Array.from(categories).sort((a, b) => {
                return a.localeCompare(b);
            });
            return sortedCategories;
        },
        filteredIntegrations() {
            const query = this.search_str.toLowerCase();
            const selectedCategory = this.selectedCategory.toLowerCase();
            return this.integrations.filter(integration => {
                const matchesSearchQuery = integration.name.toLowerCase().includes(query) ||
                    integration.description.toLowerCase().includes(query);
                if (query == '') {
                    const matchesCategory = selectedCategory === '' || integration.category.toLowerCase() === selectedCategory;
                    return matchesCategory;
                } else {
                    return matchesSearchQuery;
                }
            });
        },
    },
    created() {
        this.integrations = JSON.parse(this.integrations_json);
        this.isHovered = Array(this.integrations.length).fill(false);
    },
    mounted() {
    }
};
</script>
